// Ruta de la pantalla de acceso (auth.redirect.login en nuxt.config.js).
const LOGIN_ROUTE = '/acceder';

// Endpoints publicos de la API: un 401 en ellos significa credenciales
// incorrectas o acceso anonimo, nunca una sesion caducada.
const PUBLIC_ENDPOINTS = ['/login', '/logout', '/passwordRecovery', '/passwordReset'];

const SESSION_EXPIRED_MESSAGE = 'Su sesión ha caducado. Vuelva a acceder para continuar.';

export default function ({ $axios, app, store }) {
	// Evita que varias peticiones fallidas a la vez lancen varios cierres de sesion.
	let closingSession = false;

	const isPublicEndpoint = (config) => {
		const url = (config && config.url) || '';
		return PUBLIC_ENDPOINTS.some((endpoint) => url.includes(endpoint));
	};

	const currentPath = () =>
		app.router && app.router.currentRoute ? app.router.currentRoute.path : '';

	// Limpia la sesion en local. No se llama a /logout porque el token ya no es
	// valido y la propia llamada volveria a responder 401.
	const clearSession = () => {
		if (app.$auth) {
			app.$auth.reset();
		}
		store.commit('removeToken');
		closingSession = false;
	};

	// Cierre de sesion por token caducado: se avisa al socio y se le lleva al
	// login. Primero se navega y despues se limpia, para que el modulo auth no
	// redirija por su cuenta a la home al detectar que ya no hay sesion.
	const expireSession = () => {
		if (closingSession) {
			return;
		}
		closingSession = true;

		// En la propia pantalla de acceso no se redirige, para no encadenar
		// redirecciones sobre la misma ruta.
		if (currentPath() === LOGIN_ROUTE) {
			clearSession();
			return;
		}

		store.commit('setAlert', {
			show: true,
			message: SESSION_EXPIRED_MESSAGE,
			type: 'warning',
		});

		app.router
			.push(LOGIN_ROUTE)
			.catch(() => {})
			.then(clearSession);
	};

	$axios.onError((error) => {
		if (process.server) {
			return;
		}

		// El modulo auth aborta la peticion sin llegar a enviarla cuando el token
		// ya ha caducado en cliente. En ese caso no hay respuesta HTTP.
		if (error && error.name === 'ExpiredAuthSessionError') {
			expireSession();
			return;
		}

		const status = error && error.response ? error.response.status : null;
		if (status !== 401 || isPublicEndpoint(error.config)) {
			return;
		}

		// Si no habia sesion iniciada, el 401 es un acceso no autorizado normal y
		// lo gestiona ApiHelper.handleErrors como cualquier otro error.
		if (!app.$auth || !app.$auth.loggedIn) {
			return;
		}

		expireSession();
	});
}
